<template>
  <b-modal id="modal-3">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <!-- <div>
          <i class="fa fa-2x fa-orange fa-exclamation-triangle mb-3 slow-spin animated"></i>
        </div>-->
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <LocationCard v-if="isLocation" />
      <ContactCard v-if="isContact" />
      <div style="float: left;">
        <slot name="EditComponent"></slot>
      </div>
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div slot class="modal-footer justify-content-center" style="border:none;">
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-3')"
          aria-label="Close"
        >Cancel</b-button>
        <a type="button" class="btn btn-primary text-white" @click="save">
          Save
          <i class="fa fa-save ml-1 text-white"></i>
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import LocationCard from "@/components/cards/LocationCard.vue";
import ContactCard from "@/components/cards/ContactCard.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    LocationCard,
    ContactCard
  },
  props: {},
  mounted() {
  },
  computed: {
    ...mapState(["client"]),
    ...mapActions("saveOp", {
      prefix_DestroySaveOperation: "DestroySaveOperation",
      prefix_BuildSaveOperation: "BuildSaveOperation",
      prefix_EmitSave: "EmitSave"
    }),
    ...mapActions("client", {
      prefix_AddLocation: "AddLocation",
      prefix_AddContact: "AddContact"
    }),
    isContact() {
      return this.$store.state.client.dialogObjectType === "Contact";
    },
    isLocation() {
      return this.$store.state.client.dialogObjectType === "Location";
    }
  },
  methods: {
    saveTest() {
    },
    save() {
      this.prefix_BuildSaveOperation.then(
        this.prefix_EmitSave.then(
          this.$store.state
            .saveOp.DestroySaveOperation
        )
      );

      if (this.isLocation) {
        this.prefix_AddLocation;
      }
      if (this.isContact) {
        this.prefix_AddContact;
      }
      this.$bvModal.hide("modal-3");
    }
  },
  created() {
    this.prefix_DestroySaveOperation;
  }
};
</script>
